import { Grid } from '@material-ui/core';
import { Button, StandardDialog, TextField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface IRemoveReceivableModalProps {
  open: boolean;
  record: any;
  onClose: () => void;
  onSubmit: (comment: string) => Promise<void>;
}

export const RemoveReceivableModal = observer(({ open, record, onClose, onSubmit }: IRemoveReceivableModalProps) => {
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (open) {
      setComment('');
    }
  }, [open]);

  const handleClose = () => {
    setComment('');
    onClose();
  };

  const handleSubmit = async () => {
    await onSubmit(comment);
    handleClose();
  };

  return (
    <StandardDialog
      open={open}
      title="Remove Receivable"
      subTitle="Please provide a reason for removing this receivable from the bill."
      maxWidth="sm"
      handleClose={handleClose}
      dialogContent={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              testId="remove-receivable-reason"
              variant="outlined"
              placeholder="Enter reason"
              fullWidth
              multiline
              minRows={3}
              value={comment}
              onChange={e => setComment(e.target.value)}
            />
          </Grid>
        </Grid>
      }
      dialogActions={
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={handleClose}
            color="primary"
            variant="outlined"
            testId="remove-receivable-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            testId="remove-receivable-confirm"
            disabled={!comment?.trim()}
          >
            Confirm
          </Button>
        </>
      }
    />
  );
});
